<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: "bg-[--theme-darkest]",
  },
})
</script>

<template>
  <div class="flex w-full justify-center px-6 pt-6 md:px-16 lg:pt-16 xl:px-28">
    <div class="w-full max-w-[1288px]">
      <slot />
    </div>
  </div>
  <UBottomPanel />
</template>
